import { useState, useEffect } from 'react'

export function useScrollPosition() {
  const [scrollPosition, setScrollPosition] = useState(0)
  const [scrollPercentage, setScrollPercentage] = useState(0)

  useEffect(() => {
    const updatePosition = () => {
      const position = window.pageYOffset
      const height = document.documentElement.scrollHeight - window.innerHeight
      const percentage = (position / height) * 100

      setScrollPosition(position)
      setScrollPercentage(percentage)
    }

    window.addEventListener('scroll', updatePosition, { passive: true })
    updatePosition()

    return () => window.removeEventListener('scroll', updatePosition)
  }, [])

  return { scrollPosition, scrollPercentage }
}
